// Mock data for Tenses AI Landing Page

export const activities = [
  {
    id: 1,
    name: "Sentence Repeating",
    description: "Practice repeating sentences to improve pronunciation and memory",
    icon: "Mic",
    color: "#6366f1",
    skills: ["Pronunciation", "Memory", "Fluency"],
    tpiAlignment: { fluency: 40, pronunciation: 40, thoroughness: 20 }
  },
  {
    id: 2,
    name: "Short Stories",
    description: "Read and comprehend engaging short stories to enhance reading skills",
    icon: "BookOpen",
    color: "#8b5cf6",
    skills: ["Comprehension", "Vocabulary", "Reading"],
    tpiAlignment: { comprehension: 60, vocabulary: 30, attention: 10 }
  },
  {
    id: 3,
    name: "Just a Minute",
    description: "Answer open-ended questions to improve critical thinking and spontaneous speech",
    icon: "MessageCircle",
    color: "#ec4899",
    skills: ["Critical Thinking", "Fluency", "Confidence"],
    tpiAlignment: { fluency: 50, grammar: 30, pronunciation: 20 }
  },
  {
    id: 4,
    name: "Sentence Reading",
    description: "Practice reading sentences with proper pronunciation and intonation",
    icon: "FileText",
    color: "#3b82f6",
    skills: ["Pronunciation", "Fluency", "Accuracy"],
    tpiAlignment: { pronunciation: 40, fluency: 35, thoroughness: 25 }
  },
  {
    id: 5,
    name: "Passage Comprehensions",
    description: "Read passages and answer comprehension questions to test understanding",
    icon: "FileSearch",
    color: "#14b8a6",
    skills: ["Comprehension", "Analysis", "Attention"],
    tpiAlignment: { comprehension: 50, attention: 30, vocabulary: 20 }
  },
  {
    id: 6,
    name: "Grammar",
    description: "Learn and practice English grammar rules with interactive exercises",
    icon: "GraduationCap",
    color: "#22c55e",
    skills: ["Grammar", "Syntax", "Accuracy"],
    tpiAlignment: { grammar: 70, writing: 20, attention: 10 }
  },
  {
    id: 7,
    name: "Essay Writing",
    description: "Practice writing structured essays to enhance clarity and coherence",
    icon: "PenTool",
    color: "#f97316",
    skills: ["Writing", "Organization", "Grammar"],
    tpiAlignment: { writing: 50, grammar: 30, vocabulary: 20 }
  },
  {
    id: 8,
    name: "Jumbled Sentences",
    description: "Rearrange sentences to form meaningful and grammatically correct statements",
    icon: "Shuffle",
    color: "#eab308",
    skills: ["Grammar", "Syntax", "Logic"],
    tpiAlignment: { grammar: 50, attention: 30, comprehension: 20 }
  },
  {
    id: 9,
    name: "Story Retelling",
    description: "Listen to a story and retell it in your own words to improve comprehension and recall",
    icon: "Volume2",
    color: "#ef4444",
    skills: ["Comprehension", "Fluency", "Memory"],
    tpiAlignment: { comprehension: 40, fluency: 35, vocabulary: 25 }
  },
  {
    id: 10,
    name: "Email Writing",
    description: "Compose professional emails for real workplace scenarios and get AI-scored on tone, structure and grammar",
    icon: "Mail",
    color: "#0ea5e9",
    skills: ["Writing", "Professional Tone", "Grammar"],
    tpiAlignment: { writing: 55, grammar: 25, vocabulary: 20 }
  },
  {
    id: 11,
    name: "Error Identification",
    description: "Spot the grammatical error in a sentence - or correctly judge that there is none",
    icon: "SearchCheck",
    color: "#a855f7",
    skills: ["Grammar", "Attention to Detail", "Accuracy"],
    tpiAlignment: { grammar: 60, attention: 30, comprehension: 10 }
  }
];

export const tpiDimensions = [
  { name: "Fluency", description: "Speech flow, coherence, and ease of articulation", maxScore: 150 },
  { name: "Pronunciation", description: "Clarity, phonetic accuracy, and accent adaptation", maxScore: 150 },
  { name: "Thoroughness", description: "Consistency and task completion with precision", maxScore: 150 },
  { name: "Vocabulary", description: "Lexical range and word precision", maxScore: 150 },
  { name: "Grammar", description: "Syntactic accuracy, tense consistency, and error frequency", maxScore: 150 },
  { name: "Writing Skills", description: "Coherence, creativity, organization in written communication", maxScore: 150 },
  { name: "Comprehension", description: "Understanding and inference of spoken and written material", maxScore: 150 },
  { name: "Attention to Detail", description: "Accuracy in capturing and reproducing specific information", maxScore: 150 }
];



export const stats = [
  { value: "50K+", label: "Active Learners" },
  { value: "1200", label: "Max TPI Score" },
  { value: "11", label: "Learning Modules" }
];

/* Pricing shown on the marketing site. Static and intentionally NOT read from
   the packages API - this is the published price list, so it changes only when
   someone edits it here. GST is quoted separately (18%). */
export const pricingPlans = [
  {
    id: "3m",
    name: "3 Months",
    price: "₹1,500",
    priceValue: 1500,
    priceWithGst: "₹1,770",
    duration: "3 months",
    gstNote: "+ 18% GST",
    perMonth: "₹500/month",
    cta: "Get started",
    popular: false
  },
  {
    id: "6m",
    name: "6 Months",
    price: "₹2,000",
    priceValue: 2000,
    priceWithGst: "₹2,360",
    duration: "6 months",
    gstNote: "+ 18% GST",
    perMonth: "₹333/month",
    cta: "Get started",
    popular: true
  },
  {
    id: "12m",
    name: "12 Months",
    price: "₹2,500",
    priceValue: 2500,
    priceWithGst: "₹2,950",
    duration: "12 months",
    gstNote: "+ 18% GST",
    perMonth: "₹208/month",
    cta: "Get started",
    popular: false
  },
  {
    id: "enterprise",
    name: "Enterprise",
    price: "Custom",
    priceValue: null,
    duration: "For colleges & teams",
    perMonth: "Volume licensing",
    cta: "Contact sales",
    enterprise: true,
    popular: false
  }
];

export const allFeatures = [
  "Full access to all 11 modules",
  "Unlimited practice sessions",
  "AI-powered feedback",
  "Accuracy tracking & analytics",
  "Module assessments",
  "Dictionary with pronunciation",
  "TPI Grand Assessment",
  "Official Tenses Certificate",
  "AI interview simulator",
  "Priority support"
];

export const faqs = [
  {
    question: "What is the Tenses Proficiency Index (TPI)?",
    answer: "TPI is a comprehensive framework for assessing English language skills across 8 core dimensions: Fluency, Pronunciation, Thoroughness, Vocabulary, Grammar, Writing Skills, Comprehension, and Attention to Detail. It provides a score from 0-1200, with each dimension worth up to 150 points."
  },
  {
    question: "How does the Accuracy Score work?",
    answer: "Each activity calculates an Accuracy Score based on your performance. It moves up and down as you practise. Once you reach 80% accuracy and complete the required number of practice questions, the Module Assessment unlocks. Pass with 80% to complete the module."
  },
  {
    question: "What happens if I fail an assessment?",
    answer: "If you don't achieve the 80% cutoff in a Module Assessment, your Accuracy Score resets to 0 and you'll need to practice again before retaking. This ensures genuine mastery of each skill."
  },
  {
    question: "How do I become Tenses Certified?",
    answer: "Complete all 11 module assessments successfully, then take the TPI Grand Assessment. Upon passing, you receive your official Tenses Certificate with your TPI score, recognized globally as proof of English proficiency."
  },
  {
    question: "Is Tenses suitable for IELTS/TOEFL preparation?",
    answer: "Absolutely. The 11 modules cover every skill tested in major English proficiency exams. Many users have significantly improved their IELTS and TOEFL scores using Tenses."
  },
  {
    question: "Can I use Tenses offline?",
    answer: "Annual plan subscribers can download activities for offline practice. Your progress syncs automatically when you're back online."
  }
];

export const navLinks = [
  { name: "Activities", href: "/activities" },
  { name: "TPI", href: "/tpi" },
  { name: "Pricing", href: "/pricing" },
  { name: "Help", href: "/help" }
];

export const footerLinks = {
  product: [
    { name: "Activities", href: "/activities" },
    { name: "TPI Certification", href: "/tpi" },
    { name: "Pricing", href: "/pricing" }
  ],
  company: [
    { name: "Careers", href: "/careers" },
    { name: "Contact", href: "/contact" }
  ],
  support: [
    { name: "Help Center", href: "/help" },
    { name: "Report a Bug", href: "/help#bug-report" },
    { name: "Payment Issues", href: "/help#payment" },
    { name: "FAQ", href: "/faq" }
  ],
  legal: [
    { name: "Privacy Policy", href: "/privacy" },
    { name: "Terms of Service", href: "/terms" },
    { name: "Cookie Policy", href: "/cookies" }
  ]
};

/* ---------------------------------------------------------------------------
   Product pillars - the three things Tenses actually sells. Used by the
   "Everything in one place" section on the home page.
   ------------------------------------------------------------------------ */
export const productPillars = [
  {
    id: "practice",
    eyebrow: "Practice",
    title: "11 AI-scored modules",
    description:
      "Speaking, writing, reading and grammar - each one scored the moment you finish, with the specific reason behind every mark.",
    points: [
      "Pronunciation and fluency scored from your own voice",
      "Essays and emails judged on structure, tone and grammar",
      "Unlimited practice; your accuracy score updates live"
    ],
    icon: "Layers",
    accent: "#3459a4"
  },
  {
    id: "interview",
    eyebrow: "AI Interview",
    title: "Rehearse the real thing",
    description:
      "Pick a role, answer seven questions out loud, and get a scored report on how you actually came across.",
    points: [
      "Role-specific questions generated for each attempt",
      "Answer by voice, exactly like a live interview",
      "Per-question feedback plus an overall score"
    ],
    icon: "Mic",
    accent: "#7c3aed"
  },
  {
    id: "certification",
    eyebrow: "Certification",
    title: "A score you can put on a CV",
    description:
      "Clear every module and earn a TPI score from 0–1200 across eight measured dimensions.",
    points: [
      "Eight measured dimensions, not one vague grade",
      "Each dimension scored out of 150 points",
      "Shareable certificate with a verifiable link"
    ],
    icon: "Award",
    accent: "#0d7916"
  }
];

/* How the learning loop works - practice, unlock, prove. */
export const journeySteps = [
  {
    step: "01",
    title: "Practice until you are ready",
    description:
      "Work through any module as many times as you like. Every attempt is scored by AI and feeds a live accuracy score.",
    icon: "Repeat"
  },
  {
    step: "02",
    title: "Unlock the assessment at 80%",
    description:
      "Reach 80% accuracy and the module assessment opens. No shortcuts - the gate is what makes the result mean something.",
    icon: "Unlock"
  },
  {
    step: "03",
    title: "Clear every module",
    description:
      "Pass at 80% to complete a module. Fall short and your accuracy resets, so you go back and genuinely master it.",
    icon: "CheckCircle2"
  },
  {
    step: "04",
    title: "Sit the TPI Grand Assessment",
    description:
      "One final assessment across all eight dimensions produces your TPI score and your certificate.",
    icon: "Award"
  }
];

/* Institution / employer offer. */
export const orgFeatures = [
  {
    title: "Bulk onboarding",
    description: "Upload a spreadsheet and issue licences to a whole batch in one go.",
    icon: "Users"
  },
  {
    title: "Groups and cohorts",
    description: "Organise learners by batch, branch or department, and move them between groups anytime.",
    icon: "FolderTree"
  },
  {
    title: "Custom mock assessments",
    description: "Build a timed paper from any combination of modules and assign it to a group - or to any email for an open hackathon.",
    icon: "ClipboardList"
  },
  {
    title: "Cohort analytics",
    description: "See accuracy, completion and scores across a cohort, and export results whenever you need them.",
    icon: "BarChart3"
  }
];

/* The eight dimensions, phrased for a marketing audience. */
export const tpiHighlights = [
  { name: "Fluency", value: 128 },
  { name: "Pronunciation", value: 121 },
  { name: "Grammar", value: 134 },
  { name: "Vocabulary", value: 117 },
  { name: "Comprehension", value: 139 },
  { name: "Writing", value: 112 },
  { name: "Thoroughness", value: 124 },
  { name: "Attention", value: 130 }
];
